import React, { useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { API_URL } from '..';

const SupplierListLayer = ({ suppliersData = [] }) => {
  const history = useNavigate();
  const tableRef = useRef(null);

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${API_URL}/api/suppliers/${id}`, {
        method: 'DELETE',
        headers: {
          Accept: '*/*',
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.status === 200) {
        window.location.reload();
      } else {
        alert(`Failed to delete supplier: ${data.message}`);
      }
    } catch (error) {
      alert(`Error deleting supplier: ${error.message}`);
    }
  };

  useEffect(() => {
    // Destroy previous table (if any) before re-init
    if ($.fn.DataTable.isDataTable('#dataTable')) {
      $('#dataTable').DataTable().destroy(true);
    }

    // Unbind any previous handlers to avoid duplicates
    $('#dataTable tbody').off('click', '.edit-btn');
    $('#dataTable tbody').off('click', '.view-btn');
    $('#dataTable tbody').off('click', '.delete-btn');

    // Init table
    tableRef.current = $('#dataTable').DataTable({
      data: suppliersData,
      responsive: true,
      pageLength: 10,
      columns: [
         {
      data: null,
      title: "#",
      render: (data, type, row, meta) => {
        return meta.settings.fnRecordsDisplay() - meta.row - meta.settings._iDisplayStart;
      }
    },
        { data: 'name', title: 'Supplier Name', 
           render: (name, type, row) => {
    return `<a href="/view-supplier/${row.id}" class="text-primary">${name}</a>`;
  }
         },
        // { data: 'contact_person', title: 'Contact Person' }, // not in your model, so keep commented
        { data: 'email', title: 'Email' },
        { data: 'phone', title: 'Phone' },
        { data: 'city', title: 'City' },
        // { data: 'country', title: 'Country' },
       {
  title: 'Balance',
  data: null,
  render: function (_data, _type, row) {
    const total = Number(row.total_amount || 0);
    const opening_balance = Number(row.opening_balance || 0);
    const paid = Number(row.paid|| 0);

    const balance = opening_balance + total - paid;

    return balance.toFixed(2);
  }
},
        {
          data: 'status',
          title: 'Status',
          render: function (data) {
            const isActive = String(data).toLowerCase() === 'active';
            const cls = isActive
              ? 'badge bg-success text-light'
              : 'badge bg-danger text-light';
            return `<span class="${cls}">${data || 'N/A'}</span>`;
          },
        },
        {
          data: null,
          title: 'Actions',
          orderable: false,
          render: function (_data, _type, row) {
            return `
              <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i> Edit</a></li>
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete</a></li>
                </ul>
              </div>
            `;
          },
        },
      ],
    });

    // Bind events
    $('#dataTable tbody').on('click', '.edit-btn', function () {
      const id = $(this).data('id');
      history(`/edit-supplier/${id}`);
    });

    $('#dataTable tbody').on('click', '.view-btn', function () {
      const id = $(this).data('id');
      history(`/view-supplier/${id}`);
    });

    $('#dataTable tbody').on('click', '.delete-btn', function () {
      const id = $(this).data('id');
      handleDelete(id);
    });

    // Cleanup on unmount
    return () => {
      if ($.fn.DataTable.isDataTable('#dataTable')) {
        $('#dataTable').DataTable().destroy(true);
      }
      $('#dataTable tbody').off('click', '.edit-btn');
      $('#dataTable tbody').off('click', '.view-btn');
      $('#dataTable tbody').off('click', '.delete-btn');
    };
  }, [suppliersData, history]);

  return (
    <div className="card basic-data-table">
      <div className="card-header">
        <div className="row">
          <h5 className="col-md-6 card-title mb-0">Supplier List</h5>
          <div className="col-md-6 text-end">
            <Link className="btn btn-info" to="/supplier">
              Add New
            </Link>
          </div>
        </div>
      </div>
      <div className="card-body">
        <table className="table bordered-table mb-0" id="dataTable">
          <thead>
            <tr>
              <th>Supplier Name</th>
              {/* <th>Contact Person</th> */}
              <th>Email</th>
              <th>Phone</th>
              <th>City</th>
              {/* <th>Country</th> */}
              <th>Balance</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>{/* populated by DataTables */}</tbody>
        </table>
      </div>
    </div>
  );
};

export default SupplierListLayer;
